
const Index = () => import(/* webpackChunkName: "invoice" */ "./index");
const DueInvoice = () => import(/* webpackChunkName: "invoice" */ "./DueInvoice");
const DueInvoiceByDate = () => import(/* webpackChunkName: "invoice" */ "./DueInvoiceByDate");
const RefundInvoice = () => import(/* webpackChunkName: "invoice" */ "./RefundInvoice");
const InvoiceByDate = () => import(/* webpackChunkName: "invoice" */ "./ByDate");
const InvoiceByCustomer = () => import(/* webpackChunkName: "invoice" */ "./ByCustomer");
const InvoiceBySalesman = () => import(/* webpackChunkName: "invoice" */ "./BySalesman");

export default [{
  path: 'invoice',
  name: 'invoice-report',
  component: Index,
  redirect: {
    name: 'due-invoice'
  },
  children: [{
      path: 'due',
      name: 'due-invoice',
      component: DueInvoice,
    },
    {
      path: 'dueByDate',
      name: 'due-invoice-by-date',
      component: DueInvoiceByDate,
    },
    {
      path: 'byDate',
      name: 'invoice-by-date',
      component: InvoiceByDate,
      props: {
        title: 'Invoice By Date',
      },
    },
    {
      path: 'byCustomer',
      name: 'invoice-by-customer',
      component: InvoiceByCustomer,
    },
    {
      path: 'bySalesman',
      name: 'invoice-by-salesman',
      component: InvoiceBySalesman,
    },
    {
      path: 'refundInvoice',
      name: 'refund-invoice',
      component: RefundInvoice,
    }],
}, ]
